export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="site-logo">
    <img
      src="/assets/logo.jpg"
      alt="His & Hers Home Improvements logo"
      className="h-11 w-11 rounded-full object-cover ring-1 ring-white/15"
    />
    {!compact && (
      <div className="leading-tight">
        <span className="font-display text-lg text-zinc-100">His &amp; Hers</span>
        <span className="block text-[10px] tracking-[0.22em] text-zinc-500 uppercase">
          Home Improvements
        </span>
      </div>
    )}
  </div>
);

export const Underline = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 220 14" fill="none" preserveAspectRatio="none" aria-hidden="true">
    <path d="M3 9 C 60 3, 150 3, 217 8" stroke="#A3E635" strokeWidth="3" strokeLinecap="round" />
    <path d="M10 12 C 70 7, 160 7, 210 11" stroke="#C084FC" strokeWidth="2" strokeLinecap="round" opacity="0.8" />
  </svg>
);
